export const HEADER_BREAK_POINT = '@media screen and (min-width: 960px)';
export const resetButton = {
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    margin: '0',
    padding: '0',
    color: 'neutral.1000'
};
